/* eslint-disable @typescript-eslint/no-misused-promises */
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";
import { I18n } from "@/i18n/I18n";
import { ParameterSubjectType, ParameterType } from "@/types/parameterTypes";
import { useState } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { TitleAndIdentifierAndDescriptionFormInputs } from "./TitleAndIdentifierAndDescriptionFormInputs";
import { Parameter } from "@/backend/models/parameter";

export function EditIntroductionAssetButton({ introductionAsset }: { introductionAsset: Parameter }) {
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState<string>(introductionAsset.title);
  const [titleError, setTitleError] = useState<string | undefined>(undefined);
  const [identifier, setIdentifier] = useState<string>(introductionAsset.identifier);
  const [identifierError, setIdentifierError] = useState<string | undefined>(undefined);
  const [description, setDescription] = useState<string>(introductionAsset.description || '');
  const procedure = useProcedureInstanceStore(state => state.procedureInstance);
  const updateParameter = useParameterStore(state => state.updateParameter);

  const handleSave = async () => {
    if (!title) {
      setTitleError(I18n.get('titleRequired'));
      return;
    }
    if (identifierError || titleError || !procedure?.id) {
      return;
    }
    const parameter = {
      ...introductionAsset,
      title,
      identifier,
      description
    };
    await updateParameter({parameter}).then((response) => {
      handleClose();
      return response;
    });
  };

  const handleClose = () => {
    setShowModal(false);
    setTitle('');
    setIdentifier('');
    setDescription('');
    setTitleError(undefined);
    setIdentifierError(undefined);
  };

  return (
    <div>
      <Dropdown.Item onClick={() => setShowModal(true)}>{I18n.get('editItem', { title: introductionAsset.title })}</Dropdown.Item>
      {showModal &&
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{I18n.get('editItem', { title: introductionAsset.title })}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TitleAndIdentifierAndDescriptionFormInputs title={title} setTitle={setTitle} titleError={titleError} setTitleError={setTitleError} identifier={identifier} setIdentifier={setIdentifier} identifierError={identifierError} identifierOptional setIdentifierError={setIdentifierError} description={description} setDescription={setDescription} subjectId={procedure?.id || ''} subjectType={ParameterSubjectType.PROCEDURE} parameterType={ParameterType.INTRODUCTION} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>{I18n.get('cancel')}</Button>
            <Button type="submit" variant="primary" onClick={handleSave}>{I18n.get('confirm')}</Button>
          </Modal.Footer>
        </Modal>
      }
    </div>
  );
}
